<template>
  <header>
    <div>
      <div class="remind_box">
        <span class="discount">30% Off Everything</span>
        <span class="deadline">Prices as marked. 30% Off Everything . Ends September 2024</span>
      </div>
      <div class="portrait_box">
        <img src="../assets/logo.png" alt="logo" style="width: 348px;height: 70px" @click="toHome">
      </div>
      <div class="container">
        <recursive-menu :menu-items="menuItems" :routeValue="routeValue" mode="horizontal"/>
      </div>
    </div>

  </header>
</template>

<script>
import RecursiveMenu from './RecursiveMenu.vue'
import {buildArrList} from '../utils/utils'

export default {
  name: 'Header',
  components: {
    RecursiveMenu
  },
  props: {
    routeValue: {
      type: String
    },
  },
  data () {
    return {
      menuItems: [
        {
          id: '0',
          title: 'DESIGNS',
          children: []
        },
        {
          id: '-2',
          title: 'SEARCH'
        },
        {
          id: '-3',
          title: 'ABOUT US'
        },
      ],
    }
  },
  // 组件的其他逻辑和生命周期钩子

  created () {
    this.getMenuItem()
    this.getMaterialClassify()
  },
  methods: {
    getMenuItem () {
      this.$http({method: 'get', url: '/api/material/photograph'}).then((res) => {
        if (Object.keys(res.data).length !== 0) {
          this.menuItems.unshift({
            id: res.data.id,
            title: res.data.title
          })
        }
      })
    },
    getMaterialClassify () {
      this.$http({method: 'get', url: '/api/material/classify/tree'}).then((res) => {
        let dataList = buildArrList(res.data, 0)
        const arrList = [...dataList]
        this.menuItems.forEach((item, index) => {
          if (item.id === '0') {
            this.menuItems[index].children = arrList
          }
        })

      })
    },
    toHome () {
      if (this.$route.path !== '/') {
        this.$router.push({path: '/'})
      }
    }
  }
}
</script>

<style scoped lang="less">

header {
  text-align: center;
}

.remind_box {
  height: 80px;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  background: #4c8eff;
  color: #ffffff;

  .discount {
    font-weight: bold;
    font-size: 24px;
  }

  .deadline {
    font-weight: 400;
    font-size: 14px;
  }

}

.portrait_box {
  margin-top: 40px;
  margin-bottom: 20px;
}

.container {
  margin-top: 13px;
  display: flex;
  justify-content: center;
}

@media (min-width: 1920px) {
  .container {
    width: calc(100vw - 10px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue